export default __webpack_public_path__ + "static/media/ic_tlp1_16.6939a945.svg";